const wx = require('weixin-js-sdk')
export default {
  methods: {
    wechatShare(info){
      const that = this
      // 判断苹果手机
      let _url = ''
      if (window.__wxjs_is_wkwebview === true) {
        _url = window.location.href.split('#')[0] || window.location.href
      } else {
        _url = window.location.href
      }  
//这里是封装的axios，换成任意请求皆可
      this.$axios.post("/api/getSignFacetor",{url:_url}).then(res=>{
          var ds= res.data
        wx.config({
          debug: false,
          appId: ds.data.appId, // 必填，公众号的唯一标识
          timestamp: ds.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: ds.data.nonceStr, // 必填，生成签名的随机串
          signature: ds.data.signature, // 必填，签名，见附录1
          jsApiList: [
            "onMenuShareAppMessage",
          ] // 必填，需要使用的 JS 接口列表，所有JS接口列表见附录2
        })  
      },'json');
     
      wx.ready(() => {
        const share_title = info.title
        const share_desc = info.desc
        const share_link = info.link
        const share_img = info.img
        wx.showOptionMenu()
        wx.onMenuShareTimeline({
          title: share_title, // 分享标题
          link: share_link, // 分享链接
          imgUrl: share_img, // 分享图标           
        })
        wx.onMenuShareAppMessage({
          title: share_title, // 分享标题
          desc: share_desc, // 分享描述
          link: share_link, // 分享链接
          imgUrl: share_img, // 分享图标          
        })
      }) 
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/common/Untils.js